import React from 'react'
import redirectTo from 'utils/redirectTo'
import Toast from '../../../Common/Toast'

export interface IMeetingUpdateFailedToastProps {
  onClose: () => void
  meetingId: string
}
const MeetingFailedInvitesToast = ({ onClose, meetingId }: IMeetingUpdateFailedToastProps) => {
  return (
    <Toast variant="alert" showCloseButton={true} onClose={onClose}>
      <p>
        Meeting could not be updated. Please try to edit the meeting again.{' '}
        <span
          className="underline hover:cursor-pointer"
          onClick={() => redirectTo(`${window.location.pathname}?details=${meetingId}`)}
        >
          Click to view meeting details.
        </span>
      </p>
    </Toast>
  )
}

export default MeetingFailedInvitesToast
